
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/embeddable/global-search",
      function () {
        return require("private-next-pages/embeddable/global-search.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/embeddable/global-search"])
      });
    }
  